module.exports = __webpack_public_path__ + "img/vallicon_logo.5125279d.png";